const SET_INCIDENT = 'SET_INCIDENT';
const CLEAR_INCIDENT = 'CLEAR_INCIDENT';
const SET_RELATIONSHIPS = 'SET_RELATIONSHIPS';
const CLEAR_RELATIONSHIPS = 'CLEAR_RELATIONSHIPS';
const SET_PERIMETER = 'SET_PERIMETER';
const SET_PERIMETER_FIELDS = 'SET_PERIMETER_FIELDS';
const CLEAR_PERIMETER = 'CLEAR_PERIMETER';
const CLEAR_PERIMETER_FIELDS = 'CLEAR_PERIMETER_FIELDS';
const SET_ADS_STATUS = 'SET_ADS_STATUS';
const CLEAR_ADS_STATUS = 'CLEAR_ADS_STATUS';
const SET_PRE_INCIDENT_EXTENT = 'SET_PRE_INCIDENT_EXTENT';
const SET_NEWINCIDENT_PROTECTING_UNIT = 'SET_NEWINCIDENT_PROTECTING_UNIT';
const SET_NEWINCIDENT_IS_FS_ASSIST = 'SET_NEWINCIDENT_IS_FS_ASSIST'; 
const SET_NEWINCIDENT_IS_FIRE_CODE_REQUEST = 'SET_NEWINCIDENT_IS_FIRE_CODE_REQUEST';

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  SET_INCIDENT,
  CLEAR_INCIDENT,
  SET_PERIMETER,
  SET_PERIMETER_FIELDS,
  CLEAR_PERIMETER,
  CLEAR_PERIMETER_FIELDS,
  SET_RELATIONSHIPS,
  CLEAR_RELATIONSHIPS,
  SET_ADS_STATUS,
  CLEAR_ADS_STATUS,
  SET_PRE_INCIDENT_EXTENT,
  SET_NEWINCIDENT_PROTECTING_UNIT,
  SET_NEWINCIDENT_IS_FS_ASSIST,
  SET_NEWINCIDENT_IS_FIRE_CODE_REQUEST
};
